export const isString = v => typeof v === 'string';
